// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__BOrVS","author":"Table_author__1hHVB","authorImage":"Table_authorImage__YNe_b","unreadRow":"Table_unreadRow__3Ng31"};